export const animations = {
  fade: {
    enter: 'transition-opacity duration-200 ease-out',
    enterFrom: 'opacity-0',
    enterTo: 'opacity-100',
    leave: 'transition-opacity duration-100 ease-out',
    leaveFrom: 'opacity-100',
    leaveTo: 'opacity-0'
  },
  scale: {
    enter: 'transition-all duration-200 ease-out',
    enterFrom: 'transform scale-0 opacity-0',
    enterTo: 'transform scale-100 opacity-100',
    leave: 'transition-all duration-100 ease-out',
    leaveFrom: 'transform scale-100 opacity-100',
    leaveTo: 'transform scale-0 opacity-0'
  },
  'slide-down': {
    enter: 'transition-[max-height] duration-200 ease-in-out overflow-hidden',
    enterFrom: 'max-h-0',
    enterTo: 'max-h-[500px]',
    leave: 'transition-[max-height] duration-200 ease-in-out overflow-hidden',
    leaveFrom: 'max-h-[500px]',
    leaveTo: 'max-h-0'
  },
  'slide-left': {
    enter: 'transition-all duration-200 ease-out',
    enterFrom: 'transform -translate-x-2 opacity-0',
    enterTo: 'transform translate-x-0 opacity-100',
    leave: 'transition-all duration-100 ease-out',
    leaveFrom: 'transform translate-x-0 opacity-100',
    leaveTo: 'transform -translate-x-2 opacity-0'
  }
};
